import React, { forwardRef } from 'react';
import { Select, SelectProps } from 'antd';
import { useQuery } from 'react-query';

import { getTaskListByProccode } from 'services/workflow';

export type TaskInputProps = {
  proccode?: string;
} & SelectProps<any>; 

const TaskInput = forwardRef<any, TaskInputProps>(
  ({ proccode, ...otherProps }: TaskInputProps, ref) => {
    const { data } = useQuery(
      [proccode, 'getTaskListByProccode'],
      () =>
        getTaskListByProccode({ proccode: proccode! }).then(
          (res) => res.list || []
        ),
      {
        staleTime: 60 * 1000,
      }
    );

    return (
      <Select ref={ref as any} {...otherProps} allowClear>
        {data?.map(({ taskid, tasklabel }: any) => (
          <Select.Option value={taskid} key={taskid}>
            {tasklabel}
          </Select.Option>
        ))}
      </Select>
    );
  }
);

export default TaskInput;